import ReactSelect from 'lib/common/components/ReactSelect';
import SegmentedControls from 'lib/common/components/SegmentedControls';
import Text from 'lib/common/components/Text';
import Tooltip from 'lib/common/components/atoms/Tooltip';

import AgentDropdown from '../../AgentDropdown';
import { Tab } from '../useCreateAgentTask';

import '../styles/create-agent-task.scss';

const queueTooltipProps = {
  placement: 'top' as const,
  ariaHidden: false,
  enterDelay: 0,
  PopperProps: {
    className: 'create-agent-task__queue-tooltip',
  },
};

const getQueueOptionDescription = (description?: string) => {
  if (!description) {
    return null;
  }

  return (
    <Tooltip title={description} {...queueTooltipProps}>
      <span title={description}>
        <Text className="create-agent-task__queue-option-label-description" type="small" color="darkGrey">
          {description}
        </Text>
      </span>
    </Tooltip>
  );
};

const formatQueueOptionLabel = (option: unknown) => {
  const { label, description } = option as { label: string; description?: string };

  return (
    <div className="create-agent-task__queue-option-label">
      <Tooltip title={label} {...queueTooltipProps}>
        <span title={label}>
          <Text className="create-agent-task__queue-option-label-title" type="inline" ellipsis>
            {label}
          </Text>
        </span>
      </Tooltip>
      {getQueueOptionDescription(description)}
    </div>
  );
};

export default function TaskLocation({
  setSelectedTab,
  selectedEntity,
  selectedTab,
  queueOptionsList,
  setSelectedEntity,
}) {
  const noOptionsMessageText = 'There are no valid, available queues';

  const props = {
    id: 'create-task-assign-select',
    classNamePrefix: 'select',
    value: selectedEntity || '',
    placeholder: `Select a${selectedTab === Tab.QUEUE ? ' queue' : 'n agent'}`,
    options: selectedTab === Tab.QUEUE ? queueOptionsList : void 0,
    noOptionsMessage: selectedTab === Tab.QUEUE ? () => noOptionsMessageText : undefined,
    formatOptionLabel: formatQueueOptionLabel,
    onChange: (newValue) => setSelectedEntity(newValue),
  };

  return (
    <>
      <div className="create-agent-task__tabs">
        <SegmentedControls
          ariaLabel="Task location"
          options={Object.values(Tab).map((tab) => ({
            label: tab,
            value: tab,
          }))}
          onSelect={setSelectedTab}
          initialIndices={0}
        />
      </div>
      <div role="tabpanel">{selectedTab === Tab.AGENT ? <AgentDropdown {...props} /> : <ReactSelect {...props} />}</div>
    </>
  );
}
